import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageLocale'
})
export class LanguageLocalePipe implements PipeTransform {

  private languageMap: { [key: string]: string } = {
    'Czech': 'Čeština',
    'Dutch': 'Nederlands',
    'Danish': 'Dansk',
    'Estonian': 'Eesti',
    'Finnish': 'Suomi',
    'French': 'Français',
    'German': 'Deutsch',
    'Greek': 'Ελληνικά',
    'Hungarian': 'Magyar',
    'Italian': 'Italiano',
    'Latvian': 'Latviešu',
    'Lithuanian': 'Lietuvių',
    'Luxembourgish': 'Lëtzebuergesch',
    'Norwegian': 'Norsk',
    'Polish': 'Polski',
    'Portuguese': 'Português',
    'Slovak': 'Slovenčina',
    'Slovenian': 'Slovenščina',
    'Spanish': 'Español',
    'Swedish': 'Svenska'
  };

  transform(value: string): string {
    if (!value) {
      return value;
    }
    
    return this.languageMap[value] || value;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/language-locale.pipe.ts